import React from 'react';
import { useTranslation } from 'react-i18next';
import './ChatHeader.css';

interface ChatHeaderProps {
  onMenuClick: () => void;
}

/**
 * Header component for the chat page
 * Displays app title and mobile menu toggle
 */
function ChatHeader({ onMenuClick }: ChatHeaderProps) {
  const { t } = useTranslation();

  return (
    <header className="chat-header">
      <button
        className="menu-button"
        onClick={onMenuClick}
        aria-label="Open menu"
        type="button"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <h1>{t('auth.welcome')}</h1>
      <div className="header-spacer" />
    </header>
  );
}

export default ChatHeader;
